export default __webpack_public_path__ + "static/media/top-banner.ed61f58a.png";